module.exports = __webpack_public_path__ + "static/media/L_04.c2026361.jpg";